import { i18nFilter } from "app/filters/i18nFilter";
import { EllipsisDropdownItem } from "@similarweb/ui-components";

//
// /**
//  * Created by Eran.Shain on 6/15/2016.
//  */
//

export enum ESiteFunctionality {
    TRANSACTIONAL = 2,
    NEWS = 4,
    OTHER = 1,
}

export interface WebsiteTypeOption {
    id: string;
    text: string;
    tooltipText: string;
}

type WebsiteTypeOptions = Array<WebsiteTypeOption>;
export const getWebsiteTypeOptions = (): WebsiteTypeOptions => {
    return [
        {
            id: "2",
            text: "topsites.table.site.functionality.filter.transactional",
            tooltipText: "topsites.table.site.functionality.filter.transactional.tooltip",
        },
        {
            id: "4",
            text: "topsites.table.site.functionality.filter.news",
            tooltipText: "topsites.table.site.functionality.filter.news.tooltip",
        },
        {
            id: "1",
            text: "topsites.table.site.functionality.filter.other",
            tooltipText: "topsites.table.site.functionality.filter.other.tooltip",
        },
    ];
};

export const getWebsiteTypeItems = () => {
    return getWebsiteTypeOptions().map((websiteType) => {
        const i18n = i18nFilter();
        return (
            <EllipsisDropdownItem
                key={websiteType.text}
                id={websiteType.id}
                tooltipText={i18n(websiteType.tooltipText)}
                text={i18n(websiteType.text)}
            >
                {i18n(websiteType.text)}
            </EllipsisDropdownItem>
        );
    });
};
